/* global npVars */
/**
 * Class for ProductArchiveSearch
 */
class ProductArchiveSearch {
  /**
   * Setup modules
   *
   * @return {void}
   */
  static setupModules() {
    const moduleEl = document.querySelector(
      '.post-type-archive-product #product-search',
    );

    if (moduleEl) {
      const module = new ProductArchiveSearch(moduleEl);
      module.init();
    }
  }

  /**
   * Constructor for MyModule class
   *
   * @param {HTMLElement} moduleEl
   */
  constructor(moduleEl) {
    this.moduleEl = moduleEl;
  }

  /**
   * Initialize the module
   *
   * @return {void}
   */
  init() {
    this.addEvents();
  }

  /**
   * Add events
   *
   * @return {void}
   */
  addEvents() {
    const debouncedSearch = this.debounce(async (event) => {
      const searchString = event.target.value;
      try {
        const response = await fetch(npVars.ajax_url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
          body: new URLSearchParams({
            action: 'product_search',
            nonce: npVars.nonce,
            search: searchString,
          }),
        });
        const result = await response.text();
        document.querySelector('.product-search-results').innerHTML = result;
      } catch (error) {
        console.error('Error:', error);
      }
    }, 500); // debounce delay in ms

    this.moduleEl.addEventListener('input', debouncedSearch);
  }

  /**
   * Debounce utility
   *
   * @param {Function} func
   * @param {number} wait
   * @return {Function}
   */
  debounce(func, wait) {
    let timeout;
    return function (...args) {
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(this, args), wait);
    };
  }
}

// Wait for DOM to be interactive
if (
  document.readyState === 'interactive' ||
  document.readyState === 'complete'
) {
  ProductArchiveSearch.setupModules();
} else {
  document.addEventListener(
    'DOMContentLoaded',
    ProductArchiveSearch.setupModules,
  );
}